<template>
  <section class="sub-page iframe">
    <!-- herosection -->
    <div class="relative mt-20 mb-20">
      <img
        src="/theme-assets/images/dashboardImg.png"
        alt=""
        class="h-[260px] w-full"
      >
      <div
        class="absolute md:top-[100px] top-20 left-[15%] md:left-[25%] right-[15%] md:right-[25%] text-center"
      >
        <div class="py-10 px-10 md:px-20 bg-[#262637]">
          <p
            style="color:#1cfa78 ;"
            class="text-[#1cfa78] text-4xl"
          >
            Find your Home
          </p>
          <p class="text-[#8c8c92]">
            Get easy access to latest housing market data for Nigeria
          </p>
          <div class="flex md:gap-8 mt-8 md:flex-row flex-col gap-4">
            <select
              id="states"
              name="states"
              class="w-full rounded-sm p-2 md:w-[50%]"
            >
              <option
                v-for="(state,i) in states"
                :key="i"
                :value="state"
              >
                {{ state.stateName }}
              </option>
            </select>
            

            <select
              id="fruit"
              name="fruit"
              class="w-full rounded-sm p-2 md:w-[33%]"
            >
              <option value="apple">
                <a href="./dashboard.html">Less than 5M</a>
              </option>
              <option value="banana">
                <a
                  href="./MortgageBoard.html"
                >Between 5M and 10M</a>
              </option>
              <option value="orange">
                <a
                  href="./HousingPriceIndex.html"
                >Between 10M and 20M</a>
              </option>
              <option value="grape">
                <a
                  href="/RealEstate.html"
                >Between 20M and 50M</a>
              </option>
              <option value="grape">
                <a
                  href="/RealEstate.html"
                >Between 50M and 100M</a>
              </option>
            </select>
            <button class="bg-[#1cfa78] text-[#262637] px-4 rounded-sm">
              Search
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="w-2/3 mx-auto text-center gap-8 md:gap-0 justify-center md:justify-between flex flex-col mt-48 md:mt-32 md:flex-row"
    >
      <div class="flex items-center md:justify-normal justify-center gap-4">
        <a href="housing-market">
          <p class="text-sm">
            Connect with developer
          </p>
          <img
            src="/theme-assets/images/connectDev.png"
            alt=""
            class="h-[44px] w-[44px]"
          >
        </a>
      </div>
      <div class="flex items-center md:justify-normal justify-center gap-4">
        <p>Checkout Properties</p>
        <img
          src="/theme-assets/images/properties.png"
          alt=""
          class="h-[44px] w-[44px]"
        >
      </div>
      <div class="flex items-center md:justify-normal justify-center gap-4">
        <a href="mortgage-calculator">
          <p>Mortgage Eligibility</p>
          <img
            src="/theme-assets/images/mortgage.png"
            alt=""
            class="h-[44px] w-[44px]"
          >
        </a>
      </div>
    </div>

   

    <!--Mortgage Calculator -->
    <!-- <div class="my-16">
      <DetailedMortgageCalculator />
    </div> -->

    <!-- types of Mortgage -->
    <div
      class="flex justify-between mx-auto items-center md:flex-row flex-col gap-4 w-[90%] md:w-[70%]"
    >
      <div>
        <img
          src="/theme-assets/images/man.png"
          alt=""
          class="w-[426px] h-[744px]"
        >
      </div>

      <div class="w-full md:w-[50%] md:mb-0 mb-10 text-[#161C2D]">
        <p class="text-4xl pb-12">
          Types of Mortgage
        </p>
        <p class="text-xl pb-12">
          We share common trends and strategies for improving your rental
          income and making sure you stay in high demand.
        </p>

        <div class="flex items-center justify-between pb-6">
          <div class="flex gap-4 flex-col">
            <p class="flex items-center gap-2">
              <img
                src="/theme-assets/images/check-small.png"
                alt=""
                class="h-[12px] w-[18px]"
              > <span><h3>Fixed-rate/traditional Mortgage</h3></span>
              <br>A fixed-rate mortgage offers a straightforward, predictable monthly payment. Your interest rate—and your total monthly payment of principal and interest—will stay the same for the entire term of the loan
            </p>
            
            <p class="flex items-center gap-2">
              <img
                src="/theme-assets/images/check-small.png"
                alt=""
                class="h-[12px] w-[18px]"
              > <span><h3>Adjusted-rate Mortgage (ARM)</h3></span>
              <br>An adjustable-rate mortgage, or ARM, is a home loan with an interest rate that fluctuates periodically. This means that the monthly payments can go up or down.
            </p>
      
            <p class="flex items-center gap-2">
              <img
                src="/theme-assets/images/check-small.png"
                alt=""
                class="h-[12px] w-[18px]"
              > <span><h3>Interest-only mortgage</h3></span>
              <br>
              An interest-only mortgage is a type of mortgage in which the mortgagor (the borrower) is required to pay only the interest on the loan for a certain period.
            </p>
          </div>
        </div>

        <!-- <button class="p-2 bg-[#398559] text-white">
          Loan More
        </button> -->
      </div>
    </div>

    <!-- self EXplanatoy Video -->
    <div>
      <img
        src="/images/Video.png"
        alt=""
      >
    </div>
  </section>
</template>

<script>
import states from './states.json'

export default {
    name: 'PropertyInformation',
    components: {  },

    data: () => ({
        nav_title: 'Property Information',
        navs: [
            {
                route_name: 'property.info',
                route_title: 'Property Information',
            }
        ],
        visible: true,
        iframe: {
            src: 'https://app.powerbi.com/view?r=eyJrIjoiNWVhNTM4OTItNGMwNS00MjIwLWI5ZWUtYWQ4MzQxNmMwNTAyIiwidCI6ImE4MTNjYTk4LWU0MTMtNDJkMS1iNzNmLTlmZGM3YTJhYjhkNCIsImMiOjh9',
            loaded: false
        },
        states:states
    }),

    methods: {
      load() {
        this.iframe.loaded = true;
      },
      filterByState(){
        

      }
    },
}
</script>
<style scoped>
.iframe {
  overflow-y: hidden;
}
</style>

